/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { NbAuthJWTToken, NbOAuth2AuthStrategy, NbPasswordAuthStrategy } from '@nebular/auth';
import { environment } from '../../environments/environment';

export const socialLinks = [
  // {
  //   url: 'https://github.com/akveo/nebular',
  //   target: '_blank',
  //   icon: 'github',
  // },
  // {
  //   url: 'https://www.facebook.com/akveo/',
  //   target: '_blank',
  //   icon: 'facebook',
  // },
  // {
  //   url: 'https://twitter.com/akveo_inc',
  //   target: '_blank',
  //   icon: 'twitter',
  // },
];

export const authOptions = {
  strategies: [
    NbPasswordAuthStrategy.setup({
      name: 'email',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'Accept': 'application/json',
      },
      baseEndpoint: environment.API_BASE_URL,
      token: {
        class: NbAuthJWTToken,
        key: 'jwt',
      },
      login: {
        endpoint: '/auth/local',
        method: 'post',
      },
      register: {
        endpoint: '/auth/local/register',
        method: 'post',
      },
      logout: {
        endpoint: null,
        // method: 'post',
      },
      requestPass: {
        endpoint: '/auth/forgot-password',
        method: 'post',
      },
      resetPass: {
        endpoint: '/auth/reset-password',
        resetPasswordTokenKey: 'code',
        method: 'post',
      },
      refreshToken: {
        endpoint: '/auth/refresh-token',
        method: 'post',
      },
    }),
  ],
  forms: {
    // login: {
    //   redirectDelay: 2000
    //   socialLinks: socialLinks,
    // },
    // register: {
    //   redirectDelay: 2000
    // //   socialLinks: socialLinks,
    // },
    requestPassword: {
      redirectDelay: 4000,
    },
    validation: {
      fullName: {
        required: true,
        minLength: 6,
        maxLength: 20,
      },
    },
  },
};
